// Policy & legal page content for Suffa Matrimony (simple professional Hinglish).
// Rendered by components/suffa/PolicyPage.js on the five public policy routes.

export const POLICIES = {
  terms: {
    slug: "terms",
    title: "Terms & Conditions",
    subtitle: "Suffa Matrimony use karne ke rules — ek nazar mein samajh lein.",
    sections: [
      {
        heading: "1. About Suffa Matrimony",
        body: [
          "Suffa Matrimony ek matrimonial service hai jo Muslims ko serious aur halal marriage ke liye suitable life partner dhoondhne mein help karti hai.",
          "Suffa Matrimony dating service nahi hai. Is platform ka use sirf genuine marriage purpose ke liye kiya jana chahiye.",
        ],
      },
      {
        heading: "2. Eligibility",
        body: [
          "Suffa Matrimony par profile sirf 18 saal ya usse zyada age ke adults ki banayi ja sakti hai.",
          "Profile khud person bana sakta hai, ya unki permission aur knowledge ke saath unka immediate family member unki taraf se profile bana sakta hai.",
          "Sabhi users se umeed hai ki woh ek-doosre ke saath respectfully, honestly aur family-oriented matrimonial service ke values ke according baat-cheet karein.",
        ],
      },
      {
        heading: "3. Profile, Review & Publication",
        body: [
          "Suffa Matrimony par submit ki gayi har profile ko publish karne se pehle hamari team review karegi.",
          "Sirf profile submit karne se ye guarantee nahi hoti ki profile publish zaroor hogi. Zarurat padne par Suffa Matrimony additional information ya documents maang sakta hai, ya aisi profile/content ko reject kar sakta hai jo hamari guidelines ke according nahi hai.",
          "Aap apni profile mein jo bhi information denge, uski accuracy ki responsibility aapki hogi.",
          "Agar koi information galat, misleading ya jaan-boojhkar incorrect di gayi hai, to profile ko remove kiya ja sakta hai.",
        ],
      },
      {
        heading: "4. Service Fees",
        body: [
          "Suffa Matrimony par published profiles ko browse aur search karna free rahega.",
          "Profile add karne ke liye one-time profile service fee ₹500 applicable hogi.",
          "Agar Suffa Matrimony ke through koi rishta final hota hai aur rishta fix ho jata hai, to Successful Match Service Fee applicable hogi.",
          "Successful Match Service Fee normally ₹5,000 se ₹10,000 ke beech hogi, aur ye har side (each side) par alag-alag applicable hogi — dono sides ka combined fee nahi hai. Special cases mein fee ₹10,000 se zyada bhi ho sakti hai, as described in the Successful Match Service Fee policy.",
          "Payment lene se pehle applicable fee user ko clearly confirm ki jayegi.",
        ],
      },
      {
        heading: "5. Contact Details ki Privacy",
        body: [
          "Users ke mobile number, email address, WhatsApp number aur exact home address publicly display nahi kiye jayenge.",
          "Members ke beech contact karwane ka process Suffa Matrimony ke approved contact process ke through facilitate kiya jayega.",
        ],
      },
      {
        heading: "6. Acceptable Use",
        body: [
          "Aap Suffa Matrimony service ka misuse nahi kar sakte.",
          "Ismein harassment karna, fake ya galat information dena, illegal activity karna, ya platform ka use genuine matrimonial purpose ke alawa kisi aur purpose ke liye karna shamil hai.",
          "Agar koi account in Terms & Conditions ka violation karta hai, to Suffa Matrimony us account ko suspend ya remove kar sakta hai.",
        ],
      },
      {
        heading: "7. Marriage ki Guarantee Nahi Hai",
        body: [
          "Suffa Matrimony ka purpose suitable logon aur families ke beech genuine matrimonial introductions facilitate karna hai.",
          "Suffa Matrimony ye guarantee nahi karta ki har user ko suitable rishta milega ya marriage final hogi.",
          "Rishta accept karna, reject karna aur marriage ka final decision concerned individuals aur unki families ka hoga.",
        ],
      },
      {
        heading: "8. Tehqiq ki Zimmedari",
        body: [
          "Suffa Matrimony individuals aur families ke beech matrimonial introductions facilitate karta hai.",
          "Rishta pasand aane ya final karne se pehle identity, family background, marital status, education, profession, financial circumstances aur other relevant information ki Tehqiq concerned individuals aur families ki responsibility hogi.",
        ],
      },
      {
        heading: "9. Terms & Conditions mein Changes",
        body: [
          "Ye Terms & Conditions website ke current service rules ko describe karti hain.",
          "Future mein Terms & Conditions update ki ja sakti hain. Updated terms website par publish ki jayengi.",
        ],
      },
      {
        heading: "10. Contact",
        body: [
          "Email: suffamatrimony@gmail.com",
          "Phone: 9924610588",
        ],
      },
    ],
  },

  privacy: {
    slug: "privacy",
    title: "Privacy Policy",
    subtitle: "Aapki information kaise collect, use aur protect hoti hai.",
    sections: [
      {
        heading: "1. Hum Kaunsi Information Collect Karte Hain",
        body: [
          "Jab aap Suffa Matrimony par register karte hain ya profile banate hain, to hum aapke dwara di gayi information collect kar sakte hain.",
          "Ismein aapka naam, email address, mobile number, date of birth, education, profession, family details, lifestyle, marriage preferences aur aapke dwara upload ki gayi photos shamil ho sakti hain.",
        ],
      },
      {
        heading: "2. Kaunsi Information Public Hogi Aur Kaunsi Private Rahegi",
        body: [
          "Aapki public profile mein normally limited information dikhayi jayegi, jaise:",
        ],
        list: [
          "Calculated age",
          "City/Country",
          "Education",
          "Profession",
        ],
        after: [
          "Mobile number, email address, WhatsApp number aur income private rakhe jayenge aur publicly display nahi kiye jayenge.",
          "Full date of birth public nahi dikhayi jayegi. Uski jagah calculated age dikhayi jayegi.",
          "Photos ki visibility selected privacy setting ke according rahegi.",
        ],
      },
      {
        heading: "3. Aapki Information Ka Use Kaise Kiya Jayega",
        body: [
          "Information ka use niche diye gaye kaamon ke liye kiya jayega:",
        ],
        list: [
          "Matrimonial profile review aur completion ke liye",
          "Profile ko website par present karne ke liye",
          "Age automatically calculate karne ke liye",
          "Suitable families ke beech contact facilitate karne ke liye",
        ],
        after: [
          "Family ke beech contact Suffa Matrimony ke appropriate contact process ke through facilitate kiya jayega.",
        ],
      },
      {
        heading: "4. Aapke Device Par Information Store Hona",
        body: [
          "Jab tak profile builder prepare/complete ho raha hai, profile complete karte waqt unsaved information aur registration details browser ke local storage mein temporarily save ho sakti hain.",
          "Iska purpose ye hai ki agar user beech mein profile completion rok deta hai, to baad mein wahi se continue kar sake.",
          "Ye information browser/device mein rahegi jab tak user use submit nahi karta ya browser data clear nahi karta.",
        ],
      },
      {
        heading: "5. Information Share Karna",
        body: [
          "Suffa Matrimony personal information ko sell nahi karta.",
          "Contact details profile owner ki permission ke bina kisi ko provide nahi ki jayengi.",
          "Potential rishta aane par contact details sirf profile owner ki consent ke saath aur Suffa Matrimony team ke through, potential marriage facilitate karne ke purpose se share ki ja sakti hain.",
        ],
      },
      {
        heading: "6. Data Kitne Time Tak Rakha Jayega Aur Aapke Rights",
        body: [
          "User kisi bhi waqt contact karke:",
        ],
        list: [
          "Information dekhne ki request",
          "Galat information correct karne ki request",
          "Personal information delete karne ki request",
        ],
        after: [
          "kar sakta hai.",
          "Jo profiles submit ki gayi hain lekin publish nahi hui hain, unki information review ke liye jitne time tak zaroori ho utne time tak rakhi ja sakti hai.",
        ],
      },
      {
        heading: "7. Bachchon Ki Privacy",
        body: [
          "Suffa Matrimony ki service strictly 18 saal ya usse zyada age ke adults ke liye hai.",
          "18 saal se kam age ke kisi person ki profile accept nahi ki jayegi.",
        ],
      },
      {
        heading: "8. Contact",
        body: [
          "Email: suffamatrimony@gmail.com",
          "Phone: 9924610588",
        ],
      },
    ],
  },

  safety: {
    slug: "safety",
    title: "Safety & Community Guidelines",
    subtitle: "Har interaction safe, respectful aur genuine rakhne ke liye guidelines.",
    sections: [
      {
        heading: "1. Genuine Matrimonial Purpose Only",
        body: [
          "Suffa Matrimony ka use sirf genuine marriage purpose ke liye kiya jana chahiye. Dating ya kisi unrelated purpose ke liye platform ka misuse nahi kiya jana chahiye.",
        ],
      },
      {
        heading: "2. Fake Information / Profile Prohibited",
        body: [
          "Fake name, age, photo, marital status, education, profession ya kisi bhi important information ko jaan-boojhkar galat dena allowed nahi hai.",
        ],
      },
      {
        heading: "3. Harassment Prohibited",
        body: [
          "Kisi member ko repeatedly disturb, threaten ya harass karna prohibited hai.",
        ],
      },
      {
        heading: "4. Abusive Language Prohibited",
        body: [
          "Gaali-galauj, insulting, threatening ya disrespectful communication allowed nahi hai.",
        ],
      },
      {
        heading: "5. Inappropriate Photos / Content Prohibited",
        body: [
          "Inappropriate, offensive ya matrimonial purpose ke liye unsuitable photos/content upload nahi kiya ja sakta.",
        ],
      },
      {
        heading: "6. Fraud, Scam & Unwanted Money Requests Prohibited",
        body: [
          "Kisi member se fraud, scam, cheating ya unnecessary financial/money demand karna prohibited hai.",
        ],
      },
      {
        heading: "7. Sensitive Information Share Na Karein",
        body: [
          "OTP, password, bank details, card details ya other sensitive financial/security information kisi member ke saath share na karein.",
        ],
      },
      {
        heading: "8. Suspicious Profile Report Karein",
        body: [
          "Agar koi profile suspicious lage, to user us profile ko Report kar sakta hai.",
        ],
      },
      {
        heading: "9. Block Feature",
        body: [
          "Users unwanted ya uncomfortable interaction ko stop karne ke liye kisi member ko Block kar sakte hain.",
        ],
      },
      {
        heading: "10. Personal Information Carefully Share Karein",
        body: [
          "Apna address, workplace, financial information ya other personal details share karte waqt caution rakhein.",
        ],
      },
      {
        heading: "11. Marriage Se Pehle Tehqiq Karein",
        body: [
          "Suffa Matrimony individuals aur families ke beech matrimonial introduction facilitate karta hai.",
          "Rishta final karne se pehle identity, family background, marital status, education, profession, financial circumstances aur other relevant information ki Tehqiq user aur family ki responsibility hai.",
        ],
      },
      {
        heading: "12. Violation Par Action",
        body: [
          "Safety Guidelines ya Terms & Conditions violate hone par Suffa Matrimony profile ko warn, suspend, restrict ya remove kar sakta hai, situation ke according.",
        ],
      },
    ],
  },

  payment: {
    slug: "payment",
    title: "Payment & Refund Policy",
    subtitle: "Profile service fee, refunds aur payment security — simple shabdon mein.",
    sections: [
      {
        heading: "1. Profile Service Fee",
        body: [
          "Suffa Matrimony par profiles ko browse aur search karna free hai.",
          "Apna matrimonial profile submit karne ke liye one-time profile service fee ₹500 applicable hai.",
          "₹500 payment successful hone ke baad profile review ke liye submit ki jayegi. Payment karne se profile automatically approve ya publish hone ki guarantee nahi hai.",
        ],
      },
      {
        heading: "2. Profile Approval",
        body: [
          "Har submitted profile ko Suffa Matrimony team review karegi.",
          "Agar profile information incomplete, misleading, inappropriate ya guidelines ke against hai, to profile reject ya additional information ke liye return ki ja sakti hai.",
        ],
      },
      {
        heading: "3. ₹500 Fee Refund",
        body: [
          "₹500 profile service fee normally non-refundable rahegi.",
          "Agar user voluntarily profile process cancel karta hai, ya incorrect/incomplete information ki wajah se profile process nahi ho pati, to normally refund nahi diya jayega.",
          "Agar Suffa Matrimony ki taraf se profile process/publish karna possible nahi hota, to case review karke refund diya ja sakta hai.",
        ],
      },
      {
        heading: "4. Duplicate / Failed Payment",
        body: [
          "Agar ek hi payment accidentally do baar charge ho jati hai, to duplicate payment verify karke applicable refund process kiya jayega.",
          "Agar payment failed dikhti hai lekin amount account se deduct ho gaya hai, to payment status verify hone ke baad appropriate action liya jayega.",
        ],
      },
      {
        heading: "5. Successful Match Service Fee",
        body: [
          "Agar Suffa Matrimony ke through introduced rishta successfully final/fix hota hai, to Successful Match Service Fee applicable hogi.",
          "Normal Successful Match Service Fee ₹5,000 se ₹10,000 ke beech hogi, aur ye har side (each side) par alag-alag applicable hoti hai — dono sides ka combined fee nahi hai.",
          "Special cases mein fee ₹10,000 se zyada ho sakti hai, as described in the Successful Match Service Fee policy.",
        ],
      },
      {
        heading: "6. Payment Security",
        body: [
          "Suffa Matrimony users se OTP, password, card PIN, CVV ya banking password share karne ke liye nahi kahega.",
        ],
      },
      {
        heading: "7. Contact",
        body: [
          "Email: suffamatrimony@gmail.com",
          "Phone: 9924610588",
        ],
      },
    ],
  },

  matchFee: {
    slug: "match-fee",
    title: "Successful Match Service Fee",
    subtitle: "Successful Match Service Fee kab aur kaise applicable hoti hai.",
    sections: [
      {
        heading: "1. Fee Kab Applicable Hogi",
        body: [
          "Agar Suffa Matrimony ke through introduced profile/family ke saath rishta mutually final/fix ho jata hai, to Successful Match Service Fee applicable hogi.",
          "Ye fee har side (each side) par alag-alag applicable hoti hai — dono sides ko milakar ek combined fee nahi hai.",
        ],
      },
      {
        heading: "2. Normal Service Fee",
        body: [
          "Successful Match Service Fee normally ₹5,000 se ₹10,000 (per side) ke beech hogi.",
          "Applicable amount har side ke case ki circumstances aur services ko dekhkar decide ki jayegi.",
        ],
      },
      {
        heading: "3. Special Cases",
        body: [
          "Kuch special ya comparatively complex cases mein service fee ₹10,000 se zyada bhi ho sakti hai. Examples:",
        ],
        list: [
          "Widow / widower",
          "Divorced profile",
          "Foreigner / international profile",
          "Other cases jahan additional coordination ya special matrimonial service ki zarurat ho",
        ],
        after: [
          "Important: Sirf kisi person's status ki wajah se automatic higher fee nahi lagegi. Applicable fee case ki requirements aur services ko dekhkar decide hogi.",
        ],
      },
      {
        heading: "4. Exact Fee Pehle Batayi Jayegi",
        body: [
          "Kisi bhi Successful Match Service Fee ko charge karne se pehle user ko:",
        ],
        list: [
          "Exact amount",
          "Applicable reason/terms",
          "Payment timing",
        ],
        after: [
          "clearly communicate kiya jayega.",
          "User ko amount confirm karne ka mauka diya jayega. Hidden charges nahi honge.",
          "Ye process har side ke liye alag-alag follow ki jayegi, aur har side ka payment alag-alag record ki jayegi.",
        ],
      },
      {
        heading: "5. Fee Kab Pay Karni Hogi",
        body: [
          "Successful Match Service Fee sirf tab payable hogi jab Suffa Matrimony ke through introduced rishta mutually final/fix ho jaye.",
          "Sirf niche diye gaye maamlon par koi Successful Match Service Fee applicable nahi hogi:",
        ],
        list: [
          "Website browse karne par",
          "Profiles dekhne ya search karne par",
          "Suffa Matrimony team se contact ya general enquiry karne par",
          "Kisi profile me interest dikhane par",
          "Contact request ya baat-cheet karne par",
        ],
        after: [
          "Applicable Successful Match Service Fee rishta final/fix hone ke baad payable hogi, aur payment lene se pehle exact amount user ko clearly bataya aur confirm kiya jayega.",
        ],
      },
      {
        heading: "6. Marriage Ki Guarantee",
        body: [
          "Suffa Matrimony suitable matrimonial introductions facilitate karta hai. Marriage ka final decision individuals aur families ka hota hai.",
          "Rishta final hone ke baad agar personal ya family reasons ki wajah se marriage later cancel hoti hai, to already paid Successful Match Service Fee generally refundable nahi hogi, subject to applicable terms.",
        ],
      },
      {
        heading: "7. Tehqiq",
        body: [
          "Rishta final karne se pehle identity, family background, marital status, education, profession, financial circumstances aur other relevant information ki Tehqiq concerned individuals aur families ki responsibility hogi.",
          "Suffa Matrimony ka role individuals aur families ke beech matrimonial introductions facilitate karne tak limited hai. Suffa Matrimony marriage ki guarantee nahi deta.",
        ],
      },
    ],
  },
};

export const POLICY_LINKS = [
  { key: "terms", to: "/terms", label: "Terms & Conditions" },
  { key: "privacy", to: "/privacy", label: "Privacy Policy" },
  { key: "safety", to: "/safety-guidelines", label: "Safety & Community Guidelines" },
  { key: "payment", to: "/payment-refund", label: "Payment & Refund Policy" },
  { key: "matchFee", to: "/match-fee", label: "Successful Match Service Fee" },
];
